import { columnsCommonConfig } from 'components/common/Tables/columnsCommonConfig';
import { DefaultColumnFilter } from 'components/common/Tables/components/ColumnFilter/ColumnFilter';

import { RowOptionsCell } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/SubProgramPreferences/AliasPreferences/Cells/rowOptionsCell';

export const defaultColumn = {
    Filter: DefaultColumnFilter,
};

export const initialState = {
    sortBy: [
        {
            id: 'alias',
        },
    ],
};

export const columns = [
    {
        Header: 'Alias',
        accessor: 'alias',
        width: 300,
    },
    {
        Header: 'Activity Code',
        id: 'activityCode',
        accessor: (rowOriginal) => `${rowOriginal.scope}: ${rowOriginal.typeName}`,
        width: 580,
    },
    {
        Header: '',
        ...columnsCommonConfig.rowOptions,
        Filter: false,
        Cell: ({ row, data }) => {
            return <RowOptionsCell row={row} data={data} />;
        },
    },
];
